import { SharedAppConstants } from '@tock/shared-app-constants';

export const initialState = {
  selectedBusinessFilter: null,
  endDate: null,
  startDate: null,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.OPTION_SELECTORS_SET_DATA: {
      return {
        ...state,
        ...payload,
      };
    }
    case SharedAppConstants.OPTION_SELECTORS_SET_BUSINESS_FILTER: {
      return {
        ...state,
        selectedBusinessFilter: payload,
      };
    }
    default:
      return state;
  }
}
